import { create } from 'zustand';

// Store de autenticação
export const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('user')) || null,
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token'),
  
  setAuth: (user, token) => {
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('token', token);
    set({ user, token, isAuthenticated: true });
  },
  
  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    set({ user: null, token: null, isAuthenticated: false });
  },
  
  updateUser: (userData) => {
    const updatedUser = { ...useAuthStore.getState().user, ...userData };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    set({ user: updatedUser });
  },
}));

// Store de veículos
export const useVehicleStore = create((set) => ({
  vehicles: [],
  selectedVehicle: null,
  loading: false,
  
  setVehicles: (vehicles) => set({ vehicles }),
  
  addVehicle: (vehicle) => set((state) => ({
    vehicles: [...state.vehicles, vehicle]
  })),
  
  updateVehicle: (id, data) => set((state) => ({
    vehicles: state.vehicles.map(v => v.id === id ? { ...v, ...data } : v)
  })),
  
  removeVehicle: (id) => set((state) => ({
    vehicles: state.vehicles.filter(v => v.id !== id),
    selectedVehicle: state.selectedVehicle?.id === id ? null : state.selectedVehicle
  })),
  
  selectVehicle: (vehicle) => set({ selectedVehicle: vehicle }),
  
  setLoading: (loading) => set({ loading }),
}));

// Store de alertas
export const useAlertStore = create((set) => ({
  alerts: [],
  unreadCount: 0,
  loading: false,
  
  setAlerts: (alerts) => set({ alerts }),
  
  addAlert: (alert) => set((state) => ({
    alerts: [alert, ...state.alerts],
    unreadCount: state.unreadCount + 1
  })),
  
  markAsRead: (id) => set((state) => ({
    alerts: state.alerts.map(a => a.id === id ? { ...a, is_read: true } : a),
    unreadCount: Math.max(0, state.unreadCount - 1)
  })),
  
  markAllAsRead: () => set((state) => ({
    alerts: state.alerts.map(a => ({ ...a, is_read: true })),
    unreadCount: 0
  })),
  
  removeAlert: (id) => set((state) => {
    const alert = state.alerts.find(a => a.id === id);
    return {
      alerts: state.alerts.filter(a => a.id !== id),
      unreadCount: alert && !alert.is_read ? state.unreadCount - 1 : state.unreadCount
    };
  }),
  
  setUnreadCount: (count) => set({ unreadCount: count }),
  
  setLoading: (loading) => set({ loading }),
}));

// Store de posições
export const usePositionStore = create((set) => ({
  positions: [],
  currentPosition: null,
  loading: false,
  
  setPositions: (positions) => set({ positions }),
  
  addPosition: (position) => set((state) => ({
    positions: [position, ...state.positions],
    currentPosition: position
  })),
  
  setCurrentPosition: (position) => set({ currentPosition: position }),
  
  clearPositions: () => set({ positions: [], currentPosition: null }),
  
  setLoading: (loading) => set({ loading }),
}));

// Store de UI
export const useUIStore = create((set) => ({
  sidebarOpen: true,
  mapView: 'default',
  theme: 'dark',
  
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  
  setMapView: (view) => set({ mapView: view }),
  
  setTheme: (theme) => set({ theme }),
}));
